import React from "react";
import { Field, FieldArray, FormSection } from "redux-form";
import { SelectField, TextField } from "redux-form-material-ui";
import { MenuItem, FlatButton, IconButton } from "material-ui";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import AddIcon from "material-ui/svg-icons/content/add";
import facebookMessengerAsyncInit from "../../../../../common/facebookMessengerAsyncInit";
import config from "cfg";
import _ from "lodash";
const { bots: { messenger: { appId } } } = config;

import {
  CAMPAIGN_FORM_KEYS as FORM_KEYS,
  NOTIFICATION_TYPES
} from "dash-front/constants";
import { presence } from "dash-front/helpers/validation";
import { yCenter } from "../helpers";
import MessengerOptin from "./pickers/MessengerOptin";

const NOTIF_KEYS = FORM_KEYS.NOTIFICATIONS;
const onAdd = (fields, type) => () => fields.push({ [NOTIF_KEYS.TYPE]: type });

const NotificationsArray = ({ fields }) => {
  return (
    <div>
      {!fields.length && (
        <div
          style={{
            fontSize: "0.9em",
            color: "rgba(0, 0, 0, 0.4)",
            margin: "0px 16px"
          }}
        >
          <i>No subscribers</i>
        </div>
      )}
      {fields.map((name, index) => {
        const onRemove = () => fields.remove(index);

        return (
          <div key={name}>
            <FormSection name={name} style={yCenter}>
              <span style={{ marginRight: 12, marginTop: 24 }}>
                {index + 1}.
              </span>
              {/* <Field
                                validate={presence}
                                name={NOTIF_KEYS.TYPE}
                                component={SelectField}
                            >
                                {NOTIFICATION_TYPES.map(obj =>
                                    <MenuItem
                                        key={obj.key}
                                        value={obj.key}
                                        primaryText={obj.name}
                                    />
                                )}
                            </Field> */}
              <Field
                name={NOTIF_KEYS.VALUE}
                validate={presence}
                floatingLabelText={"Email"}
                component={TextField}
              />
              <IconButton
                style={{ marginLeft: 12, marginTop: 24 }}
                onTouchTap={onRemove}
              >
                <DeleteIcon />
              </IconButton>
            </FormSection>
          </div>
        );
      })}
      <br />
      <FlatButton
        primary
        label={"Add subscription"}
        icon={<AddIcon />}
        onTouchTap={onAdd(fields, "email")}
      />
    </div>
  );
};

class MessengerNotificationsArray extends React.PureComponent {
  state = {
    showMessengerOptin: false
  };

  componentDidMount() {
    facebookMessengerAsyncInit({
      appId
    });
  }

  handleCheck = userRef => {
    const { userId, userName, userPhoto } = this.state;
    const { fields } = this.props;
    fields.push({
      userRef,
      userName,
      userId,
      userPhoto
    });
  };

  handleUncheck = userRef => {
    const { fields } = this.props;

    const index = fields.getAll().findIndex(f => f.userRef === userRef);

    if (index > -1) fields.remove(index);
  };

  setUserInfo = () => {
    window.FB.api(
      "/me",
      { fields: "last_name,first_name,picture,id" },
      response => {
        if (!response.error) {
          this.setState({
            userName: `${response.first_name} ${response.last_name}`,
            userId: response.id,
            showMessengerOptin: true,
            initialized: true,
            userPhoto: _.get(response, "picture.data.url")
          });
        } else {
          this.setState({ showMessengerOptin: true });
        }
      }
    );
  };

  handleMessengerNotificationButtonClick = () => {
    if (!window.FB) return;

    if ((window.FB.getAccessToken() || "").length > 0) {
      this.setUserInfo();
    } else {
      window.FB.login(
        function(response) {
          if (response.authResponse) {
            this.setUserInfo();
          } else {
            console.log("User cancelled login or did not fully authorize.");
          }
        }.bind(this)
      );
    }
  };

  render() {
    const { fields } = this.props;
    return (
      <div>
        {!fields.length && (
          <div
            style={{
              fontSize: "0.9em",
              color: "rgba(0, 0, 0, 0.4)",
              margin: "0px 16px"
            }}
          >
            <i>No subscribers</i>
          </div>
        )}
        {fields.map((name, index) => {
          const onRemove = () => {
            this.setState({ showMessengerOptin: false });
            return fields.remove(index);
          };

          const field = fields.get(index);

          return (
            <div key={name}>
              <FormSection name={name} style={yCenter}>
                <span style={{ marginRight: 12, marginTop: 24 }}>
                  {index + 1}.
                </span>
                <span style={{ display: "inline-block", marginTop: 24 }}>
                  {!field.userName && <span>{field.userRef}</span>}
                  {field.userName && (
                    <span>
                      <span
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle"
                        }}
                      >
                        {field.userName}
                      </span>

                      {field.userPhoto && (
                        <img
                          style={{
                            width: "30px",
                            height: "30px",
                            marginLeft: "10px",
                            borderRadius: "50%",
                            display: "inline-block",
                            verticalAlign: "middle"
                          }}
                          src={field.userPhoto}
                          alt="_"
                        />
                      )}
                    </span>
                  )}
                </span>
                <IconButton
                  style={{ marginLeft: 12, marginTop: 24 }}
                  onTouchTap={onRemove}
                >
                  <DeleteIcon />
                </IconButton>
              </FormSection>
            </div>
          );
        })}
        <br />
        {this.state.showMessengerOptin && (
          <MessengerOptin
            onCheck={this.handleCheck}
            onUncheck={this.handleUncheck}
          />
        )}
        {!this.state.showMessengerOptin && (
          <FlatButton
            primary
            label={"Add messenger notifications"}
            icon={<AddIcon />}
            onTouchTap={this.handleMessengerNotificationButtonClick}
          />
        )}
      </div>
    );
  }
}

const NotificationsForm = () => {
  return (
    <div>
      <FieldArray name={NOTIF_KEYS.ARRAY} component={NotificationsArray} />
      <FieldArray
        name="messengerNotifications"
        component={MessengerNotificationsArray}
      />
    </div>
  );
};

export default NotificationsForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/NotificationsForm.js
 **/